import React from "react";
import { withStyles } from "@material-ui/core";
import { get, size, map, flatten } from "lodash";

import { TableRow } from "@material-ui/core";

import DashboardCard from "../DashboardCard";
import TableCellStyled from "../../Common/TableCellStyled";
import ScrollableTable from "../../Common/Table/ScrollableTable";

import colors from "../../../assets/style/colors";

const columns = [
  {
    name: "topbar_companies",
    minWidth: 200,
  },
  {
    name: "profiles_sites",
    minWidth: 200,
  },
  {
    name: "companies_zones",
    minWidth: 200,
  },
  {
    name: "dashboard_assets",
    minWidth: 200,
  },
];

const styles = {
  cell: {
    border: `3px solid ${colors.white}`,
    borderBottom: "none",
    borderLeft: "none",
    backgroundColor: colors.lightGrey,
    color: colors.black54,
  },
};

const MdcInventoryData = (props) => {
  const { classes, data } = props;

  return (
    <DashboardCard
      style={{
        margin: "24px",
      }}
    >
      <ScrollableTable columns={columns} hasMore={false} stickyHeader>
        {map(get(data, ["companies"]), (company, companyIndex) => (
          <React.Fragment key={companyIndex}>
            {map(get(company, ["sites"]), (site, siteIndex) => (
              <React.Fragment key={companyIndex * 100 + siteIndex * 10}>
                {map(get(site, ["zones"]), (zone, zoneIndex) => (
                  <TableRow key={siteIndex * 10 + zoneIndex}>
                    {siteIndex === 0 && zoneIndex === 0 && (
                      <TableCellStyled
                        className={classes.cell}
                        rowSpan={size(
                          flatten(
                            map(get(company, ["sites"]), (s) =>
                              get(s, ["zones"])
                            )
                          )
                        )}
                      >
                        {`${get(company, ["name"])} (${get(company, ["id"])})`}
                      </TableCellStyled>
                    )}
                    {zoneIndex === 0 && (
                      <TableCellStyled
                        className={classes.cell}
                        rowSpan={size(get(site, ["zones"]))}
                      >
                        {`${get(site, ["name"])} (${get(site, ["id"])})`}
                      </TableCellStyled>
                    )}
                    <TableCellStyled className={classes.cell}>
                      {`${get(zone, ["name"])} (${get(zone, ["id"])})`}
                    </TableCellStyled>
                    <TableCellStyled className={classes.cell}>
                      <ul>
                        {map(get(zone, ["assets"]), (asset, assetIndex) => (
                          <li key={assetIndex}>
                            {`${get(asset, ["name"])} (${get(asset, [
                              "total",
                            ])})`}
                          </li>
                        ))}
                      </ul>
                    </TableCellStyled>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </ScrollableTable>
    </DashboardCard>
  );
};

export default withStyles(styles)(MdcInventoryData);
